<style>
#SharedViewModal .v--modal-box.v--modal {
  min-height: 335px !important;
  min-width: 400px !important;
}
#SharedViewModal *:not(.v-icon) {
  font-size: 12px;
}
#SharedViewModal .modal__footer {
  display: none;
}
.disabledBtn {
  pointer-events: none !important;
  background: lightgray !important;
}
.disabledPointer {
  cursor: not-allowed !important;
}
</style>

<template>
  <Modal
    modalName="SharedViewModal"
    title="Widoki mapy"
    @opened="loadData"
    @closed="close"
    :buttons="[]"
  >
    <div>
      <v-layout row wrap>
        <v-subheader>Lista dostępnych widoków</v-subheader>
        <v-flex xs12>
          <v-select
            label="Wybierz widok"
            no-data-text="Brak widoków do wyświetlenia"
            :items="viewsList"
            item-text="name"
            :return-object="true"
            attach="#SharedViewModal div.flex.modal__content.xs12 > div > div > div > div"
            v-model="selectedView"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs3 v-if="selectedView">
          <v-btn style="margin-left:0" dark color="#2a579a" @click="loadView">ZAŁADUJ WIDOK</v-btn>
        </v-flex>
        <v-spacer/>
        <v-flex xs3 v-if="selectedView">
          <v-btn style="margin-right:0" dark color="red" @click="removeView">USUŃ WIDOK</v-btn>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-subheader>Dodawanie nowego widoku</v-subheader>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs8>
          <v-text-field label="Nazwa nowego widoku" v-model="newViewName"></v-text-field>
        </v-flex>
        <v-spacer/>
        <v-flex xs3>
          <button :class="{disabledPointer: !newViewName}">
            <v-btn
              :class="{disabledBtn: !newViewName}"
              style="margin-right:0"
              dark
              color="success"
              @click="addView"
            >DODAJ WIDOK</v-btn>
          </button>
        </v-flex>
      </v-layout>
    </div>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";

export default {
  components: {
    Modal
  },
  data: () => ({
    viewsList: [],
    selectedView: undefined,
    newViewName: undefined
  }),
  methods: {
    loadData() {
      this.newViewName = undefined;
      this.$store.dispatch("getViews", false).then(r => {
        this.viewsList = Array.isArray(r) ? r : [];
      });
    },
    addView() {
      this.$root.$emit("addNewView", this.newViewName);
    },
    loadView() {
      this.$root.$emit("loadNewView", this.selectedView);
    },
    removeView() {
      this.$store.dispatch("removeView", this.selectedView.token).then(r => {
        if (r.status == 200) {
          this.$root.$emit(
            "showSnackbar",
            "success",
            "Poprawnie usunięto widok"
          );
          this.selectedView = undefined;
          this.loadData();
        } else {
          this.$root.$emit("showSnackbar", "red", `${r}`);
        }
      });
    },
    close() {
      this.viewsList = [];
      this.selectedView = undefined;
      this.newViewName = undefined;
    }
  },
  mounted() {
    this.$root.$on("loadViews", this.loadData);
  }
};
</script>


// WEBPACK FOOTER //
// src/components/viewer/settings/modals/SharedViewModal.vue